import { render, staticRenderFns } from "./OldRegistrationDashboard.vue?vue&type=template&id=d870e426&"
import script from "./OldRegistrationDashboard.vue?vue&type=script&lang=js&"
export * from "./OldRegistrationDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports